import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    date_after: '',
    date_before: '',
    student: '',
  },
}

export const plopUI = createSlice({
  name: 'plopUI',
  initialState: initialState,
  reducers: {
    setDateAfter: (state, { payload }) => {
      state.tableFilters.date_after = payload
    },
    setDateBefore: (state, { payload }) => {
      state.tableFilters.date_before = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setDateAfter,
  setDateBefore,
  setStudent,
  trackActiveFilters,
  clearAllFilters,
} = plopUI.actions

export default plopUI.reducer
